const firebase = require('firebase/app').default;

let app = null;
if (process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development') {
  app = firebase.initializeApp({projectId: 'test-project', apiKey: '123', authDomain:'test-project.firebaseapp.com'});
} else {
  app = firebase.initializeApp({
    apiKey: process.env.VUE_APP_FIRE_CLIENT_API_KEY,
    authDomain: process.env.VUE_APP_FIRE_CLIENT_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIRE_CLIENT_DATABASE_URL,
    projectId: process.env.VUE_APP_FIRE_CLIENT_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIRE_CLIENT_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIRE_CLIENT_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIRE_CLIENT_APP_ID,
  });
}

module.exports = app;
